/// <reference path="../../../../../shared/models/generated/BankOperationsBankOperationReturnConvertApi.d.ts"/>

import { BasicViewService } from '../../../../../shared/services/BasicViewService';
import { AppCalculatorModel } from '../models/AppCalculatorModel';
import { User } from "../../../../../shared/models/api/User/User";
import { AbwKontoInhaberModel } from "../../../../../shared/models/view/AbwKontoInhaber";
import { AdresseModel } from "../../../../../shared/models/view/Adresse";
import { AppUtils } from '../../../../../shared/utils/index';

export class AppViewService extends BasicViewService<IbanAppDefinition> {
	private readonly lightBoxSelector: string;
	private readonly lightboxIdPrefix: string;
	private readonly inputIban: string;
	private readonly inputBic: string;
	private readonly inputAccountNumber: string;
	private readonly inputBankNumber: string;

	private readonly ibanLightboxContent: string;
	private readonly ibanTableId: string;
	private readonly bicTableId: string;
	private readonly nameTableId: string;
	private readonly firstcloseBtnClass: string;

	private readonly readonlyLightbox = 'h-invisible-lightboxcontent';

	constructor(options: BasicAppOptions<IbanAppDefinition>, user: User, loader: BasicLoader<IbanAppDefinition>) {
		super(null, options, loader);

		this.formId = this.options.contentid;
		this.lightBoxSelector = '.js-iban-lightbox';
		this.lightboxIdPrefix = "#iban_rechner";

		this.inputIban = 'input[name="Bankdaten.Iban"]';
		this.inputBic = 'input[name="Bankdaten.Bic"]';
		this.inputAccountNumber = 'input[name="Kontonummer"]';
		this.inputBankNumber = 'input[name="Bankleitzahl"]';
		this.ibanLightboxContent = '.js-iban-result-wrapper';
		this.ibanTableId = '#Iban';
		this.bicTableId = '#Bic';
		this.nameTableId = '#Name';
		this.firstcloseBtnClass = '.js-close-iban-first';
	}

	public setBankdatenModelToView(bankdatenModel: AppCalculatorModel, scope: string): void {
		const $ctx = this.getScopeCtx(scope);
		if (bankdatenModel.Iban) {
			$ctx.find(this.inputIban).val(bankdatenModel.Iban);
			$ctx.find(this.inputIban).trigger('keyup');
		}
		if (bankdatenModel.Bic) {
			$ctx.find(this.inputBic).val(bankdatenModel.Bic);
		}

		if (bankdatenModel.Kontonummer) {
			this.getLightboxAccountField(scope).val(bankdatenModel.Kontonummer);
		}
		if (bankdatenModel.Bankleitzahl) {
			this.getLightboxBankField(scope).val(bankdatenModel.Bankleitzahl);
		}

		if (bankdatenModel.HatAbweichendenKontoInhaber) {
			this.getDifferentAccountOwnerCheckbox(scope, bankdatenModel.HatAbweichendenKontoInhaber).prop('checked', true);
			this.getDifferentAccountOwnerCheckbox(scope, !bankdatenModel.HatAbweichendenKontoInhaber).prop('checked', false);
			this.openAbweichenderKontoinhabeFelder(scope);
		} else {
			this.getDifferentAccountOwnerCheckbox(scope, false).prop('checked', true);
			this.hideAbweichenderKontoinhabeFelder(scope);
		}

		if (bankdatenModel.AbwKontoInhaber) {
			if (bankdatenModel.AbwKontoInhaber.AnredeKennzeichen) {
				$ctx.find(`input[name="Bankdaten.AbwKontoInhaber.AnredeKennzeichen${scope}"][value="${bankdatenModel.AbwKontoInhaber.AnredeKennzeichen}"]`).prop('checked', true);
				if (bankdatenModel.AbwKontoInhaber.AnredeKennzeichen === 4) {
					$ctx.find('input[name="Bankdaten.AbwKontoInhaber.Firmenname"]').val(bankdatenModel.AbwKontoInhaber.Firmenname);
					$ctx.find('input[name="Bankdaten.AbwKontoInhaber.Ansprechpartner"]').val(bankdatenModel.AbwKontoInhaber.Ansprechpartner);
				}
			}
			if (bankdatenModel.AbwKontoInhaber.Titel) {
				$ctx.find('input[name="Bankdaten.AbwKontoInhaber.Titel"]').val(bankdatenModel.AbwKontoInhaber.Titel);
			}
		}
	}

	public hideIbanLightboxLink(): void {
		this.$ctx.find(".js-lightbox-iban").hide();
	}

	public hidePaymentCreditCard(hideCreditCard: boolean): void {
		if (hideCreditCard) {
			this.$ctx.find('#bank-bank').trigger('click');
		}
		this.$ctx.find('.js-payment-selection').toggleClass('h-hidden', hideCreditCard);
	}

	public getBankdatenModelFromView(scope: string): AppCalculatorModel {
		const $ctx = this.getScopeCtx(scope);
		const bankdatenModel = new AppCalculatorModel();

		bankdatenModel.Iban = ($ctx.find(this.inputIban).val() as string).replace(new RegExp(' ', 'g'), '');
		bankdatenModel.Bic = $ctx.find(this.inputBic).val() as string;
		bankdatenModel.Kontonummer = this.getLightboxAccountField(scope).val() as string;
		bankdatenModel.Bankleitzahl = this.getLightboxBankField(scope).val() as string;
		bankdatenModel.HatAbweichendenKontoInhaber = this.getDifferentAccountOwnerCheckbox(scope, true).is(":checked");
		$ctx.find('input[name="Bankdaten.HatAbwKontoInhaber"]').val(bankdatenModel.HatAbweichendenKontoInhaber ? "true" : "");
		bankdatenModel.AbwKontoInhaber = this.getAccountFormModel(scope);

		bankdatenModel.Zahlungsweise = this.$ctx.find('[name="bank"]:checked').val() as string;
		bankdatenModel.CcFirstname = this.$ctx.find('input[name="debit_owner_first"]').val() as string;
		bankdatenModel.CcLastname = this.$ctx.find('input[name="debit_owner_last"]').val() as string;
		return bankdatenModel;
	}

	public showAccountFields(scope: string): void {
		$(`${this.lightboxIdPrefix}${scope} ${this.firstcloseBtnClass}`).hide();
		const $ctx = this.getLightboxContent(scope);
		if ($ctx.hasClass(this.readonlyLightbox)) {
			$ctx.removeClass(this.readonlyLightbox).hide().slideDown();
		}
	}

	public hideAccountFields(scope: string): void {
		this.getLightboxContent(scope).addClass(this.readonlyLightbox).show().slideUp();
		$(`${this.lightboxIdPrefix}${scope} ${this.firstcloseBtnClass}`).show();
	}

	public setAccountDataToLightbox(data: BankOperationReturnConvertApi, scope: string): void {
		const $ctx = this.getLightboxContent(scope);
		$ctx.find(this.ibanTableId + scope).text(data.Iban);
		$ctx.find(this.bicTableId + scope).text(data.Bic);
		$ctx.find(this.nameTableId + scope).text(data.Name);
	}

	public closeLighbox(): void {
		$.magnificPopup.close();
	}

	private openAbweichenderKontoinhabeFelder(scope: string): void {
		const $fields = this.$ctx.find(`.ll-depend[data-depend="accountowner${scope}"]`);
		$fields.stop().slideDown(function () {
			$fields.css('height', '');
		});
	}

	private hideAbweichenderKontoinhabeFelder(scope: string): void {
		const $fields = this.$ctx.find(`.ll-depend[data-depend="accountowner${scope}"]`);
		$fields.stop().slideUp(function () {
			$fields.css('height', '');
		});
	}

	public getMultiScopeConfig(): string[] {
		const fieldsetIds = this.$ctx.find(`#${this.options.contentid}`).data("fieldsetids") as string;
		if (fieldsetIds) {
			const arr = fieldsetIds.split(",");
			const result: string[] = [];
			arr.forEach(id => {
				result.push(`-${id}`);
			});
			return result;
		}
		return [];
	}

	public getScopeFromSubmitBtn(element: EventTarget): string {
		return $(element).data("scope");
	}


	/**
	 * adds listeners to form
	 */
	public addListeners(handler: IbanViewEvents): void {
		const $form = this.getScopeCtx();

		// init form listener
		$form.find('input, select').on('change', handler.viewChangeListener.bind(handler));
		$form.on('click', '.js-lightbox-iban', handler.lightBoxListener.bind(handler));
		$form.on('change', this.inputIban, handler.ibanChangeListener.bind(handler));
		if (handler.ibanBlurListener) {
			$form.on('blur', this.inputIban, handler.ibanBlurListener.bind(handler));
		}
		if (this.options.app.showpaymentcreditcard) {
			$(window).on('ccCheckComplete', handler.creditCardCheckResponseListener.bind(handler));
			$(window).on('ccCheckError', handler.creditCardCheckErrorListener.bind(handler));
		}

		// init all form elements from ew72
		S.Utils.Lightbox.init();
		AppUtils.View.initFormElements();
	}

	/**
	 * adds listeners to form
	 */
	public addLightboxListeners(handler: IbanLightBoxEvents): void {
		const $form = this.getLightboxForm();

		// init form listener
		$form.find('input, select').on('change', handler.viewChangeListener.bind(handler));
		$('body').on('change', '.js-iban-lightbox', handler.viewChangeListener.bind(handler));
		$('body').on('click', '.js-submit-iban', handler.submitListener.bind(handler));
		$(this.ibanLightboxContent).on('click', '.js-add-iban', handler.addIbanListener.bind(handler));
	}


	private getScopeCtx(scope = ""): JQuery {
		if (scope) {
			return this.$ctx.find(`#${scope.replace("-", "")}`);
		}
		return this.$ctx.find(`#${this.formId}`);
	}

	private getAccountFormModel(scope: string): AbwKontoInhaberModel {
		const $ctx = this.getScopeCtx(scope);
		const abwKontoInhaber = new AbwKontoInhaberModel();
		abwKontoInhaber.AnredeKennzeichen = Number($ctx.find(`input[name="Bankdaten.AbwKontoInhaber.AnredeKennzeichen${scope}"]:checked`).val());
		if (scope) {
			$ctx.find('input[name="Bankdaten.AbwKontoInhaber.AnredeKennzeichen"]').val(abwKontoInhaber.AnredeKennzeichen);
		}
		if (abwKontoInhaber.AnredeKennzeichen === 4) {
			abwKontoInhaber.Firmenname = $ctx.find('input[name="Bankdaten.AbwKontoInhaber.Firmenname"]').val() as string;
			abwKontoInhaber.Ansprechpartner = $ctx.find('input[name="Bankdaten.AbwKontoInhaber.Ansprechpartner"]').val() as string;
		}
		abwKontoInhaber.Titel = $ctx.find('input[name="Bankdaten.AbwKontoInhaber.Titel"]').val() as string;
		abwKontoInhaber.Vorname = $ctx.find('input[name="Bankdaten.AbwKontoInhaber.Vorname"]').val() as string;
		abwKontoInhaber.Name = $ctx.find('input[name="Bankdaten.AbwKontoInhaber.Name"]').val() as string;
		abwKontoInhaber.Adresse = new AdresseModel();
		abwKontoInhaber.Adresse.StrasseHausnummer = $ctx.find('input[name="Bankdaten.AbwKontoInhaber.Adresse.StrasseHausnummer"]').val() as string;
		abwKontoInhaber.Adresse.Postleitzahl = $ctx.find('input[name="Bankdaten.AbwKontoInhaber.Adresse.Postleitzahl"]').val() as string;
		abwKontoInhaber.Adresse.Ort = $ctx.find('input[name="Bankdaten.AbwKontoInhaber.Adresse.Ort"]').val() as string;

		return abwKontoInhaber;
	}

	public showBicField(scope: string): void {
		AppUtils.View.hideElement(this.getBicField(scope).parents('.ll-row').first(), false);
	}

	public hideBicField(scope: string): void {
		const $bic = this.getBicField(scope);

		AppUtils.View.hideElement($bic.parents('.ll-row').first());
		$bic.parents('.ll-error-msg').first().remove();
	}

	public getIbanField(scope: string): JQuery {
		const $ctx = this.getScopeCtx(scope);
		return $ctx.find(this.inputIban);
	}

	public getBicField(scope: string): JQuery {
		const $ctx = this.getScopeCtx(scope);
		return $ctx.find(this.inputBic);
	}

	public getLightboxContent(scope: string): JQuery {
		return $(`${this.lightboxIdPrefix}${scope} ${this.ibanLightboxContent}`);
	}

	public getLightboxAccountField(scope: string): JQuery {
		return $(`${this.lightboxIdPrefix}${scope} ${this.inputAccountNumber}`);
	}

	public getLightboxBankField(scope: string): JQuery {
		return $(`${this.lightboxIdPrefix}${scope} ${this.inputBankNumber}`);
	}

	public getDifferentAccountOwnerCheckbox(scope: string, value: boolean): JQuery {
		const $ctx = this.getScopeCtx(scope);
		return $ctx.find(`input[name="HatAbweichendenKontoInhaber${scope}"][value="${value}"]`);
	}

	public getLightboxForm(): JQuery {
		return $('body').find(`${this.lightBoxSelector} form`);
	}

	/**
	 * removes validation classes for special input fields
	 */
	public removeValidationTags(): void {
		$(this.lightBoxSelector).find('input, textarea, select').removeClass('ignore-validation');
	}

	/**
	* Add form container for IBAN Lightbox due cshtml doesn't provide this.
	* This is necessary because nested forms, due initial IBAN module load and HTML placement, are not allowed.
	* Added form is placed after Lightbox container was moved up to body begin.
	* return iban jquery object
	*/
	public addFormTagToLightbox(): void {
		if (!$(this.lightBoxSelector).has('form').length) {
			$(this.lightBoxSelector)
				.wrapInner(
					'<form class="l-basic-form l-basic-form-iban l-form l-basic-form--labelontop" data-t-name="BasicForm" method="post" enctype="multipart/form-data" name="lightboxform" novalidate="novalidate"></form>');

		}
	}

	/**
	 * Moves IBAN Lightbox under body because nested forms are not allowed within markup.
	 * appendIbanLightBox
	 */
	public appendIbanLightBox(scope: string): void {
		const $calculator = this.getScopeCtx(scope).find(this.lightboxIdPrefix + scope);
		$('body').append($calculator);
	}
}
